let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jPEzh")).then(() => parcelRequire('72God'));